<template>
  <ul class="Language" v-if="show_language === true">
    <li v-for="language in languages" @click=setLocale(language.code)>
      <img height="25" :src="language.path"/>
      <span class="title">{{ language.title }}</span>
    </li>
  </ul>
</template>

<script>
import Vue from 'vue';

export default {
  data () {
    return {

    };
  },

  computed: {
    show_language () {
      return this.$store.state.Module.active_module.settings.module.show_language;
    },
    languages () {
      return [
        {
          title: 'English',
          path: '/static/img/flags/US.png',
          code: 'en'
        },
        {
          title: 'Türkçe',
          path: '/static/img/flags/TR.png',
          code: 'tr'
        },
        {
          title: 'український',
          path: '/static/img/flags/UA.png',
          code: 'ua'
        },
        {
          title: 'Русский',
          path: '/static/img/flags/RU.png',
          code: 'ru'
        },
        {
          title: 'Venezuela',
          path: '/static/img/flags/VE.png',
          code: 've'
        },
      ];
    }
  },

  methods: {
    setLocale (locale) {
      Vue.config.lang = locale;
    }
  }
};
</script>

<style scoped>
  .Language {
    display: flex;
    flex-wrap: wrap;
    font-family: 'Roboto Condensed';
    list-style: none;
    font-weight: 300;
    margin: 0;
    padding: 0;
  }
  .Language li {
    padding: 5px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// lang-selector.vue?f324f0fa